import CaretLeft from "./SVG/caretLeft.svg?react";

const CaretLeftIcon = () => {
  return <CaretLeft />;
};

export default CaretLeftIcon;
